import type { QuestionItemInput, QuestionType } from "@/lib/gql/__generated__/graphql";

import type { ForArrayType } from "@/components/features/_model/types/auto-generator-for-view-model";
import { QuestionPreQuestions } from "@/components/features/items/edit/_shared/ui/components/main/questions/pre-question";

type Props = {
	appendQuestion: () => void;
	removeQuestion: (index: number) => () => void;
	reorderQuestions: (activeId: string, overId: string) => void;
	questions: ForArrayType<QuestionItemInput[]>;
	onSetIsRequired: (index: number) => (isRequired: boolean) => void;
	onSetQuestionType: (index: number) => (input: QuestionType) => void;
	onSetTitle: (index: number) => (input: string) => void;
	appendOptionItem: (index: number) => () => void;
	removeOptionItem: (index: number) => (optionIndex: number) => void;
	onSetOptionItem: (index: number) => (optionIndex: number) => (input: string) => void;
};

export const QuestionPlanPreQuestions = ({
	appendQuestion,
	removeQuestion,
	reorderQuestions,
	questions,
	onSetIsRequired,
	onSetQuestionType,
	onSetTitle,
	appendOptionItem,
	removeOptionItem,
	onSetOptionItem,
}: Props) => {
	const title = "プラン限定の質問";
	const guide =
		"このプランを予約したゲストにのみ確認したいことがある場合はここで質問を設定してください。<br />ホテルポリシーで設定されている質問と合わせて質問されます。<br /><br />このページ上部の「英語」をクリックしていただくと、英語版の質問の設定ができます。<br />英語版の質問を設定していない場合は、言語設定が英語の場合でも、こちらで設定した質問が表示されます。";

	return (
		<QuestionPreQuestions
			title={title}
			guide={guide}
			questions={questions}
			appendQuestion={appendQuestion}
			removeQuestion={removeQuestion}
			reorderQuestions={reorderQuestions}
			onSetIsRequired={onSetIsRequired}
			onSetQuestionType={onSetQuestionType}
			onSetTitle={onSetTitle}
			appendOptionItem={appendOptionItem}
			removeOptionItem={removeOptionItem}
			onSetOptionItem={onSetOptionItem}
		/>
	);
};

QuestionPlanPreQuestions.displayName = "QuestionPlanPreQuestions";
